import {
    Component,
    ViewChildren,
    AfterViewInit,
    OnDestroy,
    OnInit,
    ChangeDetectorRef,
    QueryList,
    Input,
    Output,
    EventEmitter
} from '@angular/core';
import { CroudCompteBancaireComponent } from './croud-compte-bancaire/croud-compte-bancaire.component';
import { BanqueService } from '../../../services/Banque/banque.service';
import { TresorerieService } from '../../../services/tresorerie/tresorerie.service';
import { PaiementService } from '../../../services/paiement/paiement.service';
import { Subscription, Observable, forkJoin } from 'rxjs';
import { Banque, BanqueResponse } from '../../../models/banque.model';
import { Tresorerie } from '../../../models/Tresorerie/Tresorerie';
import { Paiement } from '../../../models/paiement/Paiement';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { StationService } from '../../../services/station.service';

@Component({
  selector: 'app-compte-bancaire',
  templateUrl: './compte-bancaire.component.html',
  styleUrls: ['./compte-bancaire.component.scss']
})
export class CompteBancaireComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() showExtraEdit = false; // control extra button
    @Input() accounts: any[] = [];
    @Input() showStatusSwitch = true;
    @Input() showDate = true;
    @Input() showSolde = false;
    @Input() showAddCard = true; // control l'affichage de la carte "Ajouter un compte bancaire"
    @Input() selectable = false; // permet la sélection des comptes
    @Input() selectedAccountId: number | null = null; // ID du compte sélectionné
    @Output() accountSelected = new EventEmitter<any>(); // Événement émis lors de la sélection

    @ViewChildren('croud') croudCompteBancaire!: QueryList<CroudCompteBancaireComponent>;
  showModal = false;
  //accounts: Banque[] = [];
  isLoading: boolean = false;
  error: string | null = null;
  idStation: number | null = null;
  switchStates: { [key: number]: boolean } = {}; 
  isAddCardActive: boolean = false; 
  file: string = environment.file_url;
  /** Base URL des fichiers uploadés (aligné document / navbar pour le logo station). */
  private urlImages = environment.url_images;
  /** Logo station depuis GET /api/settings/station/:station_id */
  stationLogoUrl: string | null = null;
  soldes: { [accountId: number]: number } = {}; // Cache pour les soldes calculés

  private subscriptions = new Subscription();

  constructor(
    private bankAccountService: BanqueService,
    private tresorerieService: TresorerieService,
    private paiementService: PaiementService,
    private toastr: ToastrService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private stationService: StationService
  ) {}

  ngOnInit(): void {
    this.loadUserData();
  }

  ngAfterViewInit(): void {
    this.croudCompteBancaire.changes.subscribe((components: QueryList<CroudCompteBancaireComponent>) => {
      if (components.length > 0 && this.showModal) {
        const croud = components.first;
        this.subscriptions.add(
          croud.close.subscribe(() => {
            this.closeModal();
            this.isAddCardActive = false; 
          })
        );
        this.subscriptions.add(
          croud.accountAdded.subscribe((newAccount: Banque) => {
            console.log('✅ [CompteBancaireComponent] Nouveau compte ajouté:', newAccount);
            // Recharger les comptes bancaires après l'ajout
            if (this.idStation !== null) {
              this.loadBankAccounts();
            } else {
              // Si idStation n'est pas défini, le charger depuis localStorage
              this.loadUserData();
              if (this.idStation !== null) {
                this.loadBankAccounts();
              }
            }
          })
        );
        this.subscriptions.add(
          croud.accountUpdated.subscribe((updatedAccount: Banque) => {
            if (this.idStation !== null) {
              this.loadBankAccounts();
            }
   
            if (updatedAccount.id) {
              this.switchStates[updatedAccount.id] = updatedAccount.statut;
              this.cdr.detectChanges();
            }
          })
        );
      }
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  loadUserData(): void {
    const user = localStorage.getItem('currentUser');
    if (user) {
      const currentUser = JSON.parse(user);
      if (currentUser?.stations?.length > 0) {
        this.idStation = currentUser.stations[0].id;
        console.log('idStation:', this.idStation);
        this.loadStationLogo();
        this.loadBankAccounts();
      } else {
        this.toastr.error('Aucune station trouvée. Veuillez créer une station.', 'Erreur');
        this.router.navigate(['/create-station']);
      }
    } else {
      this.toastr.error('Utilisateur non connecté.', 'Erreur');
      this.router.navigate(['/pages/authentication/login-v2']);
    }
  }

  /**
   * Charge le logo depuis GET /api/settings/station/:station_id (champ station.logo).
   */
  private loadStationLogo(): void {
    if (this.idStation === null) {
      return;
    }
    this.stationService.getStation(this.idStation).subscribe({
      next: (res: any) => {
        const station = res?.station;
        if (!station?.logo) {
          this.stationLogoUrl = null;
          this.cdr.detectChanges();
          return;
        }
        const raw = String(station.logo).trim();
        if (raw.startsWith('data:')) {
          this.stationLogoUrl = raw;
        } else if (raw.startsWith('http://') || raw.startsWith('https://')) {
          this.stationLogoUrl = raw;
        } else {
          const logoPath = raw.startsWith('/') ? raw : `/${raw}`;
          this.stationLogoUrl = `${this.urlImages}${logoPath}`;
        }
        this.cdr.detectChanges();
      },
      error: () => {
        this.stationLogoUrl = null;
        this.cdr.detectChanges();
      }
    });
  }

  /**
   * URL affichée sur la carte : logo station (API settings) si disponible, sinon logo du compte bancaire.
   */
  getAccountLogoSrc(account: any): string {
    if (this.stationLogoUrl) {
      return this.stationLogoUrl;
    }
    const path = account?.logo;
    if (path) {
      return this.file + path;
    }
    return '';
  }

  loadBankAccounts(): void {
    if (this.idStation === null) {
      this.error = 'Aucune station disponible.';
      return;
    }
    this.isLoading = true;
    console.log('Calling getBanques with idStation:', this.idStation);
    this.bankAccountService.getBanques(this.idStation).subscribe({
      next: (data: BanqueResponse) => {
        console.log('API Response for getBanques:', data);
        this.accounts = data.banques || [];

        this.accounts.forEach(account => {
          if (account.id) {
            this.switchStates[account.id] = account.statut;
            console.log('Logo URL for account', account.id, ':', this.file + account.logo);
            // Calculer le solde pour chaque compte si showSolde est activé
            if (this.showSolde) {
              this.calculateSolde(account.id);
            }
          }
        });
        console.log('Accounts after update:', this.accounts);
        if (this.accounts.length === 0) {
          console.warn('No accounts retrieved from API.');
        }
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('Error loading bank accounts:', err);
        console.log('Error status:', err.status, 'Message:', err.message);
        this.error = 'Erreur lors du chargement des comptes bancaires: ' + (err.message || 'Erreur inconnue');
        this.toastr.error(this.error, 'Erreur');
        this.isLoading = false;
      }
    });
  }

  openModal(type: 'ajouter' | 'update' | 'etat', account?: Banque, newStatut?: boolean): void {
   /* if (this.idStation === null) {
      this.toastr.error('Impossible d\'ajouter ou modifier : aucune station disponible.', 'Erreur');
      return;
    }

    */
      console.log(this.idStation)
    this.showModal = true;
    if (type === 'ajouter') {
      this.isAddCardActive = true; 
    }
    this.cdr.detectChanges();
    setTimeout(() => {
      const croud = this.croudCompteBancaire.first;
      if (croud) {
        if (type === 'etat' && account) {
          const action = account.statut ? 'Désactivation' : 'Activation';
          croud.openModal(type, { ...account }, this.idStation || undefined, `${action} du compte bancaire`);
        } else if (type === 'ajouter' || type === 'update') {
          croud.openModal(type, account ? { ...account } : undefined, this.idStation || undefined);
        }
      } else {
        console.warn('croudCompteBancaire not available yet.');
      }
    }, 0);
  }

  toggleSwitch(account: Banque): void {
    if (account.id) {
      this.switchStates[account.id] = !this.switchStates[account.id]; 
      this.openModal('etat', account);
      this.cdr.detectChanges();
    }
  }

  closeModal(): void {
    this.showModal = false;
    this.isAddCardActive = false; 
    if (this.idStation !== null) {
      this.loadBankAccounts();
    }
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleString('fr-FR', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  detailbanque(account?: any) {
      const compteBancaireId = account?.id || account?.compte_bancaire_id;
      if (compteBancaireId) {
          this.router.navigate(['/comptabilite/banque/detail'], {
              queryParams: { compte_bancaire_id: compteBancaireId }
          });
      } else {
          this.router.navigate(['/comptabilite/banque/detail']);
      }
  }

  /**
   * Gère le clic sur un compte bancaire lorsque selectable est activé
   */
  onAccountClick(account: any): void {
    if (this.selectable) {
      this.accountSelected.emit(account);
    }
  }

  /**
   * Calcule le solde d'un compte bancaire en additionnant les montants affichés dans detail-banque
   * - Débit (dépense) → montant négatif
   * - Crédit → montant positif
   */
  private calculateSolde(compteBancaireId: number): void {
    console.log(`💰 [CompteBancaireComponent] Calcul du solde pour compte_bancaire_id: ${compteBancaireId}`);
    
    forkJoin({
      tresorerie: this.tresorerieService.getTresorerieByCompteBancaire(compteBancaireId),
      paiements: this.loadPaiementsByBanqueId(compteBancaireId)
    }).subscribe({
      next: (results: { tresorerie: Tresorerie[], paiements: Paiement[] }) => {
        let soldeTotal = 0;

        // Calculer le solde à partir des opérations de trésorerie
        results.tresorerie.forEach(tresorerie => {
          const montant = parseFloat(tresorerie.montant || '0');
          if (tresorerie.type_paiement === 'debit') {
            // Débit = dépense = négatif
            soldeTotal -= montant;
          } else if (tresorerie.type_paiement === 'credit') {
            // Crédit = recette = positif
            soldeTotal += montant;
          }
        });

        // Calculer le solde à partir des paiements
        results.paiements.forEach(paiement => {
          if (paiement.lignes_paiement && paiement.lignes_paiement.length > 0) {
            paiement.lignes_paiement.forEach(ligne => {
              // Vérifier si la ligne correspond au compte bancaire OU est de type espece
              const matchesBanqueId = ligne.banque_id === compteBancaireId;
              const matchesEspece = ligne.type_paiement === 'espece';
              
              if (matchesBanqueId || matchesEspece) {
                const montant = parseFloat(ligne.montant || '0');
                // Les paiements sont toujours en DÉBIT (dépense) selon detail-banque
                soldeTotal -= montant;
              }
            });
          }
        });

        // Stocker le solde calculé
        this.soldes[compteBancaireId] = soldeTotal;
        console.log(`✅ [CompteBancaireComponent] Solde calculé pour compte ${compteBancaireId}: ${soldeTotal.toFixed(3)} TND`);
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error(`❌ [CompteBancaireComponent] Erreur lors du calcul du solde pour compte ${compteBancaireId}:`, error);
        // En cas d'erreur, définir le solde à 0
        this.soldes[compteBancaireId] = 0;
        this.cdr.detectChanges();
      }
    });
  }

  /**
   * Charge tous les paiements qui ont des lignes avec le banque_id OU des lignes de type espece
   */
  private loadPaiementsByBanqueId(banqueId: number): Observable<Paiement[]> {
    return new Observable(observer => {
      this.paiementService.getPaiements().subscribe({
        next: (response: any) => {
          let paiements: Paiement[] = [];
          
          // Normaliser la réponse
          if (Array.isArray(response)) {
            paiements = response;
          } else if (response && response.data) {
            if (Array.isArray(response.data)) {
              paiements = response.data;
            } else if (response.data.paiements && Array.isArray(response.data.paiements)) {
              paiements = response.data.paiements;
            }
          }

          // Filtrer les paiements qui ont des lignes avec le banque_id OU des lignes de type espece
          const paiementsFiltres = paiements.filter(paiement => {
            if (!paiement.lignes_paiement || paiement.lignes_paiement.length === 0) {
              return false;
            }
            
            return paiement.lignes_paiement.some(ligne => {
              const matchesBanqueId = ligne.banque_id === banqueId;
              const matchesEspece = ligne.type_paiement === 'espece';
              return matchesBanqueId || matchesEspece;
            });
          });
          
          observer.next(paiementsFiltres);
          observer.complete();
        },
        error: (error) => {
          console.error('❌ [CompteBancaireComponent] Erreur lors du chargement des paiements:', error);
          observer.next([]);
          observer.complete();
        }
      });
    });
  }

  /**
   * Retourne le solde formaté pour un compte bancaire
   */
  getSolde(accountId: number | undefined): string {
    if (!accountId || !this.showSolde) {
      return '0,000';
    }
    const solde = this.soldes[accountId] || 0;
    return solde.toLocaleString('fr-FR', { minimumFractionDigits: 3, maximumFractionDigits: 3 });
  }
}
